import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ProcessingBar2 from "../../../components/ProcessingBar/ProcessingBar2";
import ProcessingBarBlack from "../../../components/ProcessingBar/ProcessingBlack";

const Promotion = () => {
  const navigate = useNavigate();
  const [showProcessing, setShowProcessing] = useState(false);
  const [showProcessingCall, setShowProcessingCall] = useState(false);

  const handleregister = () => {
    setShowProcessing(true);
    setTimeout(() => {
      setShowProcessing(false); // (optional: hide after processing)
      navigate("/register");
    }, 2000);
  };

  const handleBookACall = () => {
    setShowProcessingCall(true);
    setTimeout(() => {
      setShowProcessingCall(false);
      navigate("/contact/book-a-call");
    }, 2000);
  };

  return (
    <section className="bg-dry py-12 px-4">
      <div
        className="max-w-5xl mx-auto flex flex-col lg:flex-row rounded-3xl overflow-hidden bg-redlight"
        data-aos="fade-up"
      >
        {/* Image section */}
        <div className="lg:w-1/2 w-full">
          <img
            src="/images/galery/img_03.jpg" // Replace with your image
            alt="Timely Salon App"
            className="w-full h-full object-cover"
          />
        </div>

        {/* Text + CTA */}
        <div className="lg:w-1/2 w-full flex flex-col justify-center px-8 py-12">
          <h2 className="text-4xl text-dry mb-6">
            Try{" "}
            <span className="text-red-500 font-semibold drop-shadow-md">
              Lokalai
            </span>
            <br />
            for your business
          </h2>
          <p className="text-gray-700 text-base mb-8">
            30 day free trial. No obligations. Nothing to lose!
          </p>

          <div className="flex flex-row sm:flex-row items-start sm:items-center gap-4">
            <button
              onClick={handleregister}
              className="bg-dry text-redlight px-6 py-3 rounded-full font-semibold text-sm transition-transform duration-200 hover:scale-105 w-[200px] h-[45px]"
            >
              {showProcessing ? (
                <div className="flex items-center justify-center w-full h-full">
                  <ProcessingBar2 />
                </div>
              ) : (
                "Start your free trial"
              )}
            </button>

            <button
              onClick={handleBookACall}
              className="relative text-dry text-sm font-semibold pb-1 after:absolute after:left-0 after:bottom-0 after:h-[2px] after:w-full after:bg-[#2f2f38] after:transition-all after:duration-200 hover:after:w-0 min-w-[100px] h-[40px] flex items-center justify-center"
            >
              {showProcessingCall ? <ProcessingBarBlack /> : "Talk to us"}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Promotion;
